import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createButtonIconOnly } from './ButtonIconOnly';
import { BUTTON_ICON_ONLY_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(BUTTON_ICON_ONLY_BASE_CLASSNAME), createButtonIconOnly, NO_PATTERN_BUSINESS_LOGIC);
